import {
  Cell,
  CellHyperlinkValue,
  CellRichTextValue,
  ValueType,
} from "exceljs";

export const strictCellValueTypeIsRichText = (
  cell: Cell
): cell is Cell & { value: CellRichTextValue } => {
  return cell.type === ValueType.RichText;
};

export const strictCellValueTypeIsString = (
  cell: Cell
): cell is Cell & { value: string } => {
  return cell.type === ValueType.String;
};

export const strictCellValueTypeIsHyperlink = (
  cell: Cell
): cell is Cell & { value: CellHyperlinkValue } => {
  return cell.type === ValueType.Hyperlink;
};

export type NoTranslateCell = {
  row: number;
  column: number;
  locked?: boolean;
};

export type ExcelFileViewerMode = "edit" | "view";
